import * as yup from 'yup';
import { MODERATOR_MESSAGE_FIELD_NAME_DEFAULT } from 'src/entities/moderation/ui/moderatorMessageField/const';
import { ModerationMessageFormModel } from 'src/entities/moderation';

export interface FormModel extends ModerationMessageFormModel {
  name: string;
  surname: string;
  birthDate: string;
  location?: string;
  cityId?: number;
  cityFiasId?: string;
  address?: string;
}

export const validationSchema: yup.ObjectSchema<FormModel> = yup.object({
  name: yup.string().required('Введите имя'),
  surname: yup.string().required('Введите фамилию'),
  birthDate: yup.string().required('Введите дату рождения'),
  location: yup.string().optional(),
  cityId: yup.number().optional(),
  cityFiasId: yup.string().optional(),
  address: yup.string().optional(),
  [MODERATOR_MESSAGE_FIELD_NAME_DEFAULT]: yup.string().required('Введите текст'),
  sendCopyBySms: yup.bool().optional(),
});

export type FormSchemaType = yup.InferType<typeof validationSchema>;
